import { AppContext } from "@components/features/appContext/AppContext";
import Layout from "@components/primitives/layout/Layout";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import Banner from "./components/Banner";
import Information from "./components/Information";
import { appPath } from "@routes/app";
import Video from "./components/Video";

function HomePage() {
  const { language } = useContext(AppContext);

  return (
    <Layout>
      <Helmet>
        <title>{createTitle(translation(language).header.home)}</title>
      </Helmet>
      <div className="h-full w-full pt-20 pb-20">
        <Banner />
        <div className="p-5 py-16 grid md:grid-cols-3 grid-cols-1 grid-rows-4 gap-5 bg-primary">
          <Video />
          <Information
            title={translation(language).home.informations.members.title}
            description={
              translation(language).home.informations.members.description
            }
            icon="users"
            to={appPath.members}
            toLabel={
              translation(language).home.informations.members.buttonLabel
            }
          />
          <Information
            title={translation(language).home.informations.events.title}
            description={
              translation(language).home.informations.events.description
            }
            icon="calendar"
            to={appPath.events}
            toLabel={translation(language).home.informations.events.buttonLabel}
          />
          <Information
            title={translation(language).home.informations.contact.title}
            description={
              translation(language).home.informations.contact.description
            }
            icon="envelope"
            to={appPath.contact}
            toLabel={
              translation(language).home.informations.contact.buttonLabel
            }
          />
        </div>
      </div>
    </Layout>
  );
}

export default HomePage;
